var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 736,
    height: 423,
    viewBox: "0 0 736 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M738.5 4.5C491.667 -7.66666 -0.900015 58.9 3.49999 422.5",
    stroke: "url(#paint0_linear_2_33)",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_33",
    x1: 700.5,
    y1: -3.99998,
    x2: 14.5,
    y2: 361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#C0B7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#8176AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343045"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/vector3.a9fa3bf139bf9de6dc00cca30008d24f.svg";
export { ForwardRef as ReactComponent };